import { ConversationMarkdown } from '../ConversationMarkdown'
import { MessageContentStyled } from './styles/MessageContentStyled'
import { MessageRowStyled } from './styles/MessageRowStyled'

export type MessageSender = 'user' | 'llm'

export interface IMessageProps {
  sender: MessageSender
  content: string
}

export const Message = ({ sender, content }: IMessageProps) => (
  <MessageRowStyled $sender={sender}>
    <MessageContentStyled $sender={sender}>
      <ConversationMarkdown content={content} />
    </MessageContentStyled>
  </MessageRowStyled>
)
